<template>
  <div>
    <NavBar />
    <AuthBySessionExpired />
    <div class="container">
      <form v-on:submit="execute">
        <div class="row">
          <div class="col-md-12 pt-0 pb-0">
            Selecione o anexo
            <input id="document_pdf" class="form-control-file" type="file" />
            <p class="mb-0 mt-3 text-info-img">
              Tamanho máximo <strong>10MB</strong>
            </p>
            <p class="text-info-img">
              Formatos: <strong>PDF, JPG, JPEG, PJPEG</strong> e
              <strong>PNG</strong>
            </p>
          </div>
          <div class="col-md-12 pt-1 pb-0">
            <ErrorsMessages :errors="errors" />
          </div>
          <div class="col-md-12 pb-0 text-right">
            <v-btn class="btn-save" type="submit" :disabled="loading"
              >VERIFICAR</v-btn
            >
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import NavBar from "../templates/NavBar";

import AuthBySessionExpired from "../templates/Components/AuthBySessionExpired";

import ErrorsMessages from "../templates/Components/ErrorsMessages";

import api from "../services/api";

import routes from "../routes";

export default {
  name: "VerifyPDF",

  components: {
    NavBar,
    AuthBySessionExpired,
    ErrorsMessages,
  },

  data() {
    return {
      data: [],

      errors: [],

      loading: false,
    };
  },

  created() {
    this.retrieve();
  },

  methods: {
    async retrieve() {
      routes;
    },

    async execute(event) {
      try {
        event.preventDefault();

        let documentForm = document.getElementById("document_pdf");

        const form = new FormData();

        let document_pdf = documentForm.files[0];

        if (!document_pdf) {
          this.errors = ["Informe o PDF"];
          return;
        }

        const allowedMimes = ["application/pdf"];

        if (!allowedMimes.includes(document_pdf.type)) {
          this.errors = ["Formato de arquivo inválido, aceito apenas PDF"];
          return;
        }

        form.append("document_pdf", document_pdf, document_pdf.name);

        this.loading = true;

        const response = await api.post("/certificate/verify-pdf", form);

        const { error, errors } = response.data;

        if (!error) {
          this.errors = [];
          document.getElementById("document_pdf").value = "";
        } else {
          this.errors = errors;
        }

        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },

    handleToDrive: (link) => window.open(link, "_blank"),
  },
};
</script>
